import getUser from './getUser';
import updateUser from './updateUser';

export default {
	namespaced: true,
	modules: {
		getUser, updateUser
	}
}
